module.exports = __webpack_public_path__ + "static/media/feature-10.383b9435.jpg";